import login from "./modules/login";
import system from "./modules/system";
import product from "./modules/product";
import country from "./modules/country";
import brand from "./modules/brand";
import material from "./modules/material";
import productType from "./modules/productType";
import salePerson from "./modules/salePerson";
import createCode from "./modules/createCode";
import dictionaries from "./modules/dictionaries";
import inquiryCode from "./modules/inquiryCode";
import mediaType from "./modules/mediaType";
import brandType from "./modules/brandType";
import activities from "./modules/activities";
import marketingEnd from "./modules/marketingEnd";
import marketingSX from "./modules/marketingSX";
import shootTJ from "./modules/shootTJ";
import area from "./modules/area";
import newQrCode from "./modules/newQrCode";
import codeStyle from "./modules/codeStyle";
import scanStatistics from "./modules/scanStatistics";
import generatedCode from './modules/generatedCode'

const stores = {
    login,
    system,
    product,
    country,
    brand,
    material,
    productType,
    salePerson,
    createCode,
    dictionaries,
    inquiryCode,
    mediaType,
    brandType,
    activities,
    marketingEnd,
    marketingSX,
    shootTJ,
    area,
    newQrCode,
    codeStyle,
    scanStatistics,
    generatedCode
};
export default stores;